import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { RemainingPlusTag } from './tag-wrapper-remaining-plus-tag'

import styles from './tag-wrapper.module.css'

const propTypes = {
    items: PropTypes.node,
    maxTooltipItems: PropTypes.number,
    tagClassName: PropTypes.string
}

function RemainingTagsContainer({ items, maxTooltipItems, tagClassName }) {
    const tags = items.slice(0, maxTooltipItems).map((item, index) => {
        return (
            !!item &&
            React.cloneElement(item, {
                className: cx(styles['remaining-tag'], tagClassName, 't3sel-tag-wrapper-remaining-tag'),
                key: `tag-wrapper-remaining-tag-${index}`
            })
        )
    })

    const numRemainingItems = items.length - maxTooltipItems
    const renderedTags =
        numRemainingItems > 0
            ? tags.concat(
                  <RemainingPlusTag
                      key="tag-wrapper-remaining-plus-tag"
                      {...{
                          className: tagClassName,
                          numRemainingItems
                      }}
                  />
              )
            : tags

    return <div className={cx(styles['remaining-tag-container'], 't3sel-remaining-tag-container')}>{renderedTags}</div>
}

RemainingTagsContainer.propTypes = propTypes

export { RemainingTagsContainer }
